import { useEffect, useMemo, useState } from 'react'

import type { IMessage } from '@/types/chat'

export default function useReAnswer(item: IMessage) {
  const { answer_list } = item
  const [curIndex, setCurIndex] = useState<number>(
    item.answer_list?.length || 0,
  )
  const [renderItem, setRenderItem] = useState(item)

  const getCurRenderItem = (index: number) => {
    if (index === answer_list.length) {
      return item
    } else {
      return {
        answer_list,
        ...answer_list[index],
      }
    }
  }

  useEffect(() => {
    if (item.answer_id === renderItem.answer_id || renderItem.loading) {
      setRenderItem(item)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item])

  // 手动切换展示，手动更新renderItem
  const handleNext = () => {
    if (curIndex === answer_list.length) {
      setRenderItem(getCurRenderItem(0))
      setCurIndex(0)
    } else if (curIndex + 1 === answer_list.length) {
      setRenderItem(getCurRenderItem(answer_list.length))
      setCurIndex(answer_list.length)
    } else {
      setRenderItem(getCurRenderItem(curIndex + 1))
      setCurIndex(curIndex => curIndex + 1)
    }
  }

  const handlePre = () => {
    if (curIndex === 0) {
      setRenderItem(getCurRenderItem(answer_list.length))
      setCurIndex(answer_list.length)
    } else {
      setRenderItem(getCurRenderItem(curIndex - 1))
      setCurIndex(curIndex => curIndex - 1)
    }
  }

  return {
    curIndex,
    renderItem,
    handleNext,
    handlePre,
  }
}
